import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PrimeNGConfig } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  private langChangeSubscription = new Subject<string>();
  langChange$ = this.langChangeSubscription.asObservable();

  private LANG_KEY = 'lang';
  private langList: string[];

  constructor(private translate: TranslateService, private primeConf: PrimeNGConfig) {
    this.langList = environment.langList;
  }

  setInitialLang(): Observable<any> {
    this.translate.setDefaultLang(environment.defaultLang);
    // onLangChange odpala się także przy pierwszym use(), więc pokrywa initial load
    this.translate.onLangChange.subscribe(() =>
      this.translate.get('primeng').subscribe(res => this.primeConf.setTranslation(res)));
    return this.translate.use(this.getLanguage());
  }

  getLanguage(): string {
    const lang: string | null = localStorage.getItem(this.LANG_KEY);
    if (lang) return lang;
    else return environment.defaultLang;
  }

  setLanguage(lang: string): void {
    this.translate.use(lang).subscribe(() => {
      localStorage.setItem(this.LANG_KEY, lang);
      this.langChangeSubscription.next(lang);
    });
  }

  getLangList(): string[] {
    return this.langList;
  }


  translateNestedSingle(messageKey: string, nestedValueKey: string, nestedMessage: string): Observable<string> {
    return this.translateNested(messageKey, { [nestedValueKey]: nestedMessage });
  }

  translateNested(messageKey: string, nestedTranslations: any): Observable<string> {
    if (nestedTranslations && Object.keys(nestedTranslations).length) {
      return this.translate.get(Object.values(nestedTranslations))
        .pipe(
          switchMap(translations => {
            const params = {};
            Object.keys(nestedTranslations)
              .forEach(element => params[element] = translations[nestedTranslations[element]]);
            return this.translate.get(messageKey, params);
          })
        );
    } else {
      return this.translate.get(messageKey);
    }
  }

}
